/**
 * Finds the route value for the specified enumeration.
 *
 * @template T The type of the enumeration.
 * @param {string} route The route to search for a value.
 * @param {T} enumObject The enumeration object.
 * @returns {T[keyof T] | number} The route value, or 0 if the value is not found.
 */
export const findRouteValue = <T>(route: string, enumObject: T): T[keyof T] | number => {
  for (const key in enumObject) {
    if (route.includes(key)) {
      return enumObject[key as keyof T];
    }
  }
  return 0;
};
